import { render, staticRenderFns } from "./CorrectionDelivered.vue?vue&type=template&id=3e74b374&"
import script from "./CorrectionDelivered.vue?vue&type=script&lang=js&"
export * from "./CorrectionDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports